/**
 * The one sentence every copy kept only in this browser carries, wherever
 * it is offered: the gallery's device cards and its in-progress cards, and
 * the File menu's Keep on this device. Browser storage is exactly what an
 * iPad reinstall wipes (owner report: a saved sculpt gone with the app),
 * so it says so where the choice is made, in the same words each time.
 */
export const DEVICE_ONLY_NOTE = 'On this device only. A reinstall or clearing the browser loses it.';
